const formFieldTypography = {
  fontSize: '16px',
  fontWeight: 500,
  color: '#162936',
};

export const FORM_FIELD_MAX_WIDTH = '320px';

export const formFieldContainerSx = {
  width: FORM_FIELD_MAX_WIDTH,
  flexShrink: 0,
};

const formFieldBorderColor = '#737F86';
const formFieldFocusBorderColor = '#2F736E';

/** Apply on OutlinedInput root (Select) or nested under TextField */
const formOutlinedBorderStyles = {
  '& fieldset': {
    borderColor: formFieldBorderColor,
    borderRadius: '4px',
  },
  '&:hover fieldset': {
    borderColor: formFieldBorderColor,
  },
  '&.Mui-focused fieldset': {
    borderColor: formFieldFocusBorderColor,
    borderWidth: '2px',
  },
};

export const formTextFieldStyles = {
  ...formFieldContainerSx,
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    ...formOutlinedBorderStyles,
  },
  '& .MuiInputBase-input': {
    ...formFieldTypography,
  },
};

/** SelectWithLabel — sx is applied on Select (OutlinedInput root), use & fieldset directly */
export const formSelectFieldStyles = {
  width: '100%',
  borderRadius: '4px',
  backgroundColor: '#FFFFFF',
  ...formOutlinedBorderStyles,
  '& .MuiSelect-select': {
    ...formFieldTypography,
    display: 'flex',
    alignItems: 'center',
  },
  '.MuiSvgIcon-root': {
    fill: '#2F736E !important',
  },
};
